import { all, fork } from 'redux-saga/effects';

import { takeLoginRequest } from './loginSaga';
import { takeLogOutRequest } from './logOutSaga';

const authSagaRequest = function* () {
    yield all([fork(takeLoginRequest), fork(takeLogOutRequest)]);
};

export { authSagaRequest };
